import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IPageData, UIError } from 'common/interfaces';
import { IRole } from 'common/interfaces/irole';
import { IUser, IUserState } from 'common/interfaces/iuser';

const initialState: IUserState = {
  loading: false,
  error: null,
  users: null,
  roles: null,
  pagingInfo: null,
  storeAdmins: null,
  franchiseeAdmins: null,
  roleIdMap: null,
  roleNameMap: null,
} as IUserState;

const reducers = {
  setLoading: (state: IUserState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: IUserState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
  },
  resetContext: (state: IUserState) => {
    state = initialState;
  },
  setUsers: (state: IUserState, action: PayloadAction<IPageData<IUser> | null>) => {
    console.log('Setting user list in redux.....', action.payload);
    state.users = action.payload;
  },
  addUsers: (state: IUserState, action: PayloadAction<IPageData<IUser> | null>) => {
    if (action.payload) {
      const stUsers = state.users?.items || [];
      const payLoadUsers = action.payload.items || [];
      state.users = {
        ...action.payload,
        items: [...stUsers, ...payLoadUsers],
      };
    }
  },
  setRoles: (state: IUserState, action: PayloadAction<IPageData<IRole> | null>) => {
    console.log('Setting user roles in redux.....', action.payload);
    state.roles = action.payload;
    if (action.payload) {
      const roleIdMap = {} as { [id: number]: IRole };
      const roleNameMap = {} as { [name: string]: IRole };
      action.payload.items.forEach((itm) => {
        roleIdMap[itm.id] = itm;
        roleNameMap[itm.roleName] = itm;
      });
      state.roleIdMap = roleIdMap;
      state.roleNameMap = roleNameMap;
    }
  },
  setStoreAdminUsers: (state: IUserState, action: PayloadAction<IPageData<IUser> | null>) => {
    state.storeAdmins = action.payload;
  },
  setFranchiseeAdminUsers: (state: IUserState, action: PayloadAction<IPageData<IUser> | null>) => {
    state.franchiseeAdmins = action.payload;
  },
};

const userSlice = createSlice({
  name: 'IUserState',
  initialState: initialState,
  reducers: reducers,
});

export default userSlice.reducer;
export const UserActions = userSlice.actions;
